// 文件管理
import http from "@/jslibs/axios/http";

// 文件列表
export const list = (data) => http.get(`/v1/cms/file`, data);

// 文件添加
export const add = (data) => http.post(`/v1/cms/file`, data);

// 文件编辑
export const edit = ({ uuid, ...data }) => http.put(`/v1/cms/file/${uuid}`, data);

// 文件详情
export const detail = ({ cuuid, ...data }) => http.get(`/v1/cms/file/${cuuid}`, data);

// 文件删除
export const del = ({ cuuid }) => http.delete(`/v1/cms/file/${cuuid}`);